import React from 'react';
import { IconProps } from 'utils/types';

const SpinnerIcon = ({
	color = 'currentColor',
	height = '20',
	width = '20',
	size,
}: IconProps) => {
	return (
		<svg
			width={size || width}
			height={size || height}
			viewBox='0 0 20 20'
			fill={color}
			xmlns='http://www.w3.org/2000/svg'
		>
			<g>
				<path
					d='M9.99995 20C8.22097 19.9996 6.47431 19.5246 4.94011 18.6241C3.4059 17.7236 2.1397 16.4301 1.27209 14.877C0.404486 13.324 -0.0331149 11.5676 0.00442446 9.78899C0.0419638 8.01041 0.553284 6.27404 1.48565 4.75897C2.41801 3.2439 3.73767 2.00498 5.3085 1.16998C6.87934 0.334989 8.64448 -0.0658492 10.4219 0.00881249C12.1993 0.0834742 13.9246 0.630932 15.4199 1.59472C16.9152 2.55851 18.1263 3.90374 18.9283 5.49167C18.9816 5.58972 19.0146 5.69747 19.0254 5.80853C19.0363 5.91959 19.0247 6.0317 18.9914 6.13821C18.9581 6.24471 18.9038 6.34344 18.8316 6.42855C18.7594 6.51365 18.6709 6.58339 18.5712 6.63363C18.4716 6.68387 18.3629 6.71358 18.2515 6.72101C18.1402 6.72844 18.0285 6.71343 17.9231 6.67688C17.8176 6.64032 17.7206 6.58296 17.6378 6.5082C17.5549 6.43344 17.4879 6.34281 17.4408 6.24167C16.5962 4.56935 15.2127 3.23043 13.5136 2.44101C11.8146 1.65159 9.89906 1.45774 8.07629 1.89075C6.25351 2.32375 4.62983 3.35835 3.4673 4.82755C2.30478 6.29674 1.67125 8.11482 1.66897 9.98831C1.66669 11.8618 2.29579 13.6814 3.45474 15.1534C4.61368 16.6255 6.23484 17.664 8.05656 18.1015C9.87827 18.5389 11.7942 18.3497 13.4952 17.5644C15.1962 16.7791 16.5829 15.4436 17.4316 13.7733C17.5358 13.5833 17.7098 13.4413 17.9169 13.3775C18.124 13.3137 18.3478 13.333 18.5409 13.4314C18.7339 13.5299 18.8811 13.6996 18.9511 13.9047C19.021 14.1098 19.0084 14.3341 18.9158 14.53C18.0828 16.1787 16.8079 17.5633 15.2335 18.5293C13.6591 19.4952 11.8471 20.0044 9.99995 20Z'
					fill={color}
				/>
			</g>
		</svg>
	);
};

export default SpinnerIcon;
